define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/form_errors_behavior",
    "templates/account/internal_transfer_item.html",
    "forms/account/internal_transfer_form",
    "backbone.syphon"
], function ($, _, Marionette, FormErrorsBehavior, InternalTransferTemplate, InternalTransferForm) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            'submit': '.ct_btn8',
            'add': '#add_transfer',
            'form': '#transfer_form',
            'table': '#transfer_table',
            'remove': '.minus_sign',
            'fromSelect': '.from_mt4_selectbox',
            'toSelect': '.to_mt4_selectbox',
            'transferableMt4': '#transferable_mt4',
            'withdrawable': '#withdrawable',
            'transferAlert': '#transfer_alert',
            'transferAlertMessage': '#transfer_alert_message',
        },

        events: {
            'click @ui.submit': 'submit',
            'click @ui.add': 'addRow',
            'click @ui.remove': 'removeRow',
            'change @ui.fromSelect': 'updateToSelect',
            'change @ui.toSelect': 'updateFromSelect',
            'change @ui.transferableMt4': 'updateFinancial'
        },

        initialize: function () {
            this.bindUIElements();

            this.idx = parseInt(window.rows) - 1;

            this.mt4DropdownOptions = window.mt4_drop_down_options;
            this.mtDropdownOptions = window.mt_drop_down_options;
            this.translatorFrom = window.translatorFrom;
            this.translatorTo = window.translatorTo;
            this.translatorAmount = window.translatorAmount;
            // this.updateToSelect();
            this.updateFinancial();

            if (window.post_to_mt4_list) {
                $(".from_mt4_selectbox").trigger('change')
                $(".to_mt4_selectbox").trigger('change')
                let i = 0;
                for (const mt4 of window.post_to_mt4_list) {
                    $(`.to_mt4_selectbox[data-idx='${i}']`).val(mt4);
                    i++;
                }
            }
        },

        addRow: function (e) {
            if (e) e.preventDefault();

            this.idx++;

            this.ui.table.append(
                InternalTransferTemplate({
                    idx: this.idx,
                    mt4DropDownOptions: this.mt4DropdownOptions,
                    translatorFrom: this.translatorFrom,
                    translatorTo: this.translatorTo,
                    translatorAmount: this.translatorAmount
                })
            )
        },

        removeRow: function (e) {
            if (e) e.preventDefault();

            var idx = $(e.currentTarget).attr('data-idx');
            this.$('#row_' + idx).hide();
            this.$('#row_' + idx).remove();

            this.blockTransfer()
        },

        updateToSelect: function (e) {
            this._updateToFromSelect(e, 'to');
        },

        updateFromSelect: function (e) {
            this._updateToFromSelect(e, 'from');
        },

        updateFinancial: function () {
            var that = this;

            $.ajax({
                url: '/rest_internal_transfer/get_transferable_amount',
                data: {
                    account_no: this.ui.transferableMt4.val()
                },
                success: function (data, res) {
                    that.ui.withdrawable.html(data.currencySymbol + ' ' + data.amount);
                },
                error: function (data, error) {
                }
            })
        },

        submit: function (e) {
            this.ui.form.submit();
        },

        blockTransfer: function (mt4AccountNo) {
            const that = this

            const account_info = window.accounts_info.find(a => a.mt4AccountNo == mt4AccountNo);
            if (mt4AccountNo && account_info.canTransfer == false) {
                that.ui.transferAlert.removeClass('hidden')
                that.ui.transferAlertMessage.text(`(${mt4AccountNo}) ${account_info.reasons[0]}`)
                that.ui.submit.attr('disabled', true);
            } else {
                that.ui.transferAlert.addClass('hidden')
                that.ui.submit.attr('disabled', false);

                this._updateAlertMessage()
            }
        },

        _updateAlertMessage: function () {
            const selectFroms = $("[id^='from_mt4_']");
            const idxArray = [];

            selectFroms.each(function () {
                const id = $(this).attr('id'); // #from_mt4_%d pattern id
                const number = id.match(/\d+$/);

                if (number) {
                    idxArray.push(number[0]);
                }
            });
            idxArray.reverse()

            for (const idx of idxArray) {
                const selectedMt4 = $(`#from_mt4_${idx}`).data('selectedMt4')
                if (!selectedMt4) {
                    continue
                }

                const account_info = window.accounts_info.find(a => a.mt4AccountNo == selectedMt4)

                if (account_info.canTransfer == false) {
                    this.ui.transferAlertMessage.text(`(${selectedMt4}) ${account_info.reasons[0]}`)
                    this.ui.transferAlert.removeClass('hidden')
                    this.ui.submit.attr('disabled', true);
                    break;
                }
            }
        },

        _updateToFromSelect: function (e, toUpdate) {
            var idx = $(e.currentTarget).attr('data-idx');
            var currentVal = $(e.currentTarget).val();
            var $select = $('#' + toUpdate + '_mt4_' + idx);


            if (toUpdate == 'to') {
                $('#from_mt4_' + idx).data('selectedMt4', currentVal);
                this.blockTransfer(currentVal)
            }

            // Don't change the master
            if ("true" == $select.attr('data-isMaster')) {
                return;
            }

            // Empty and re-add the empty option
            var selectedVal = $select.val();
            $select.empty();
            $select.append('<option value=""></option>');

            if ('' === currentVal) {
                // $.each(this.mt4DropdownOptions, function(val, text) {
                //     $select.append('<option value="'+val+'">'+text+'</option>');
                // });

                // This is not the master anymore since we just resetted, both can become masters.
                $(e.currentTarget).attr('data-isMaster', "false");
            } else {
                var options = {};
                // if(currentVal > 1000000 && currentVal < 3000000){
                //     options = this.mtDropdownOptions['mt5'];
                // } else {
                //     options = this.mtDropdownOptions['mt4'];
                // }
                currentVal = Number(currentVal);
                options = this.mtDropdownOptions;

                // Cannot transfer to the same account
                var newOptions = _.filter(options, function (item) {
                    return (item !== currentVal);
                });

                $.each(newOptions, function (val, text) {
                    $select.append('<option value="' + text + '">' + text + '</option>');
                });
                // This was selected first and is the master.
                $(e.currentTarget).attr('data-isMaster', "true");
            }

            // Keep the same value selected (if it's still available)
            $select.val(selectedVal);
        },
    });
});